import styled from 'styled-components';

import { BaseStyle } from '@nhl/nhl-breakaway-ui';

// This is the size when both tables are visible
const tableWidth = 672;

export const FullCenteredContainer = styled.div`
    display: flex;
    justify-content: center;

    ${BaseStyle.Mixins.screenSizes.extraLarge} {
        justify-content: end;
    }
`;

export const ActionItemContainer = styled.div`
    display: flex;
    justify-content: end;
    padding: 10px;

    max-width: ${tableWidth}px;
    width: calc(90vw - 10px);

    button {
        display: none;
        margin-left: 20px;
    }

    ${BaseStyle.Mixins.screenSizes.large} {
        button {
            display: block;
        }
    }
`;

export const Position = styled.div`
    ${BaseStyle.Mixins.fontStyles.ui['16b']};
    padding-top: 64px;
    padding-left: 16px;
    padding-bottom: 16px;
`;
